import { render, staticRenderFns } from "./AttachImageForm.vue?vue&type=template&id=c2a23468&scoped=true&"
import script from "./AttachImageForm.vue?vue&type=script&lang=js&"
export * from "./AttachImageForm.vue?vue&type=script&lang=js&"
import style0 from "./AttachImageForm.vue?vue&type=style&index=0&id=c2a23468&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2a23468",
  null
  
)

export default component.exports